var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper chart-wrapper--gauge h-100 w-100 d-flex align-items-center",attrs:{"dir":"ltr"}},[_c('canvas')])}]

export { render, staticRenderFns }